import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export const Home = () => {
  const { t } = useTranslation(); //defaultNS is "common"

  return (
    <Box textAlign="center">
      <Box
        component="img"
        src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f"
        alt="Team working"
        sx={{ width: '100%', height: 320, objectFit: 'cover', borderRadius: 2, boxShadow: 3, mb: 4 }}
      />
      <Typography variant="h3" gutterBottom>{t("welcome")}</Typography>
      <Typography variant="h6">{t("tagline")}</Typography>
    </Box>
  );
};